var config = require("./url-config");

var httpNeedLoginCodes = "#300#301#302#";

var onNeedLoginFunc;

function init(needLoginFunc) {
    onNeedLoginFunc = needLoginFunc;
}


function post(params) {
    // 如果传递了上下文，则发起一个加载过程
    let loading = null;

    if(params.that) {
        loading = params.that.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)'
        });
    }

    $.ajax({
        method: 'POST',
        url: params.url,
        data: {
            req: JSON.stringify(params.req || {}),
            ver: config.version,
        },
        success: function (res) {
            closeLoading(loading);

            if(!res || !res.result) {
                onFailed(res, params);
            } else {
                if(!res.result.success) {
                    onResFailed(res, params);
                } else {
                    onSuccess(res, params);
                }
            }
        },
        error: function (res) {
            closeLoading(loading);

            onFailed(res, params);
        },
        complete: function (res) {
            closeLoading(loading);

            onComplete(res, params);
        }
    })
}

function closeLoading(loading) {
    if(loading) {
        try {
            loading.close();
        } catch (e) {}
    }
}

function onComplete(res, params) {
    if(params.complete) {
        params.complete();
    }
}

function onSuccess(res, params) {
    if(params.xmsuccess) {
        params.xmsuccess(res);
    }
}

function onResFailed(res, params) {
    console.error('http post failed url : ' + params.url + " res : " + JSON.stringify(res));

    // TODO: Homer 2018/2/6 web这里处理的不是很好，需要登录时直接跳到登录页面
    // 跳完登录页返回后应该继续发送协议而不是在这里直接xmfail了
    // 但是考虑到web是页面跳转而不是在当前页授权式的登录
    // 所以也可以接受，不过还是有优化的空间
    if(params.xmfail) {
        params.xmfail(res);
    }

    // 如果是登录本身出问题，就不走一遍了
    if(-1 !== httpNeedLoginCodes.indexOf("#" + res.result.code + "#") && config.loginUrl !== params.url) {
        // cookie 有问题，需要重新登录一次，重新登录成功以后，再访问一次
        if(params.that) {
            // params.that.$router.push('/');
            params.that.$emit('showDetail',false);
        } else {
            if(onNeedLoginFunc) {
                onNeedLoginFunc(params);
            }
        }
    }
}

function onFailed(res, params) {
    console.error('http post failed url : ' + params.url + " res : " + JSON.stringify(res));

    if(params.fail) {
        params.fail(res);
    }
}

module.exports = {
    init: init,
    post: post
};



//////////////////
// WEBPACK FOOTER
// ./static/js/httputil.js
// module id = 2G1J
// module chunks = 1